module.exports = __webpack_public_path__ + "pc/img/ico-arrow-up.b197b462.svg";